export default __webpack_public_path__ + "static/media/mid_spenders.c88ff687.svg";